import { render } from "./RPIScoreCard.vue?vue&type=template&id=7e47ba49"
import script from "./RPIScoreCard.vue?vue&type=script&lang=js"
export * from "./RPIScoreCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__